import React, { useContext } from 'react';
import { SidebarMenu } from '../molecules';
import { Outlet } from 'react-router-dom';
import { UserContext } from '../../contexts';
import { Logo } from '../atoms';
import styled, { css } from 'styled-components';

const PageLayout = styled.div`
  display: flex;
  min-height: 100vh;
`;

type Props = {
  currentUserRole: string;
};

const Sidebar = styled.div(
  ({ theme }) => css`
    position: sticky;
    top: 0;
    flex: 0 0 355px;
    box-shadow: ${theme.colors.main.boxShadow};
    background-color: ${theme.colors.main.primary};

    @media (max-width: ${theme.breakpoints.max.lg}) {
      flex: 0 0 300px;
    }

    @media (max-width: ${theme.breakpoints.max.md}) {
      flex: 0 0 245px;
    }

    @media (max-width: ${theme.breakpoints.max.sm}) {
      flex: 0 0 18%;
      min-width: 160px;
    }
  `
);

const SidebarContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: auto;
  position: sticky;
  top: 0;
`;

const LogoContainer = styled.div<Props>(
  ({ theme, currentUserRole }) => css`
    padding: 7px 30px;
    background-color: ${currentUserRole === 'platformUser'
      ? theme.colors.main.font
      : theme.colors.main.primary};

    @media (max-width: ${theme.breakpoints.max.md}) {
      padding: 7px 15px;
    }
  `
);

const SidebarTemplate = () => {
  const { user } = useContext(UserContext);
  return (
    <PageLayout>
      <Sidebar>
        <SidebarContent>
          <LogoContainer currentUserRole={user.userType}>
            <Logo />
          </LogoContainer>
          <SidebarMenu />
        </SidebarContent>
      </Sidebar>
      <Outlet />
    </PageLayout>
  );
};

export { SidebarTemplate };
